/*
 * WrapInterval - jQuery Plugin
 * Simple way wrap intervals of items
 *
 * Author	Erik Lindgren
 *
 * Version:	1.0 (03-02-2015)(d-m-y)
 *
 */

(function( $ ) {
    $.fn.wrapInterval = function( wrap, num ) {
		var arr = [];
		var w = 0;

		this.each(function( i ) {
			if( i > 0 && i % num === 0 ) {
				w++;
			}

			if( typeof(arr[w]) !== "object" ) {
				arr[w] = $();
			}

			arr[w] = arr[w].add(this);
		});

		for( var c = 0; c !== arr.length; c++ ) {
			arr[c].wrapAll( wrap );
		}

		return this;
    };
})( jQuery );